import { writable } from 'svelte/store';

export type SearchCombobox = ReturnType<typeof createSearchCombobox>;

export const createSearchCombobox = () => {
	const open = writable(false);

	return {
		states: { open }
	};
};
